module.exports = __webpack_public_path__ + "img/tddg-3.59066d4f.webp";